var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.franchiseId
    ? _c(_setup.FormControlPlainText, {
        attrs: { value: _setup.franchiseTitle, "form-id": _vm.formId },
      })
    : _c(
        "div",
        [
          _c(
            _setup.FormControlTypeRelationshipOneToMany,
            _vm._g(
              _vm._b(
                {},
                "FormControlTypeRelationshipOneToMany",
                _vm.$props,
                false
              ),
              _vm.$listeners
            )
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }